import { createReducer } from '../../../store.model';

import {
    ActionType,
    Recalculate,
    ReloadResult,
} from './observation.focus.summary.action';
import { calculateMain } from './observation.focus.summary.model';
import {
    defaultFocusSummaryState,
    FocusSummaryState,
} from './observation.focus.summary.state';

const { builder, reducer } = createReducer<ActionType, FocusSummaryState>(
    defaultFocusSummaryState(),
);

builder.add<ReloadResult>(
    ActionType.COACHING__FOCUS_SUMMARY__RELOAD_RESULT,
    (state, action) => {
        const next = calculateMain(
            action.payload.interactionEntity,
            action.payload.evaluationsDetails,
            action.payload.interactions,
            action.payload.published,
            false,
        );

        return {
            ...state,
            evaluationsDetails: action.payload.evaluationsDetails,
            calculationResult: next,
        };
    },
);

builder.add<Recalculate>(
    ActionType.COACHING__FOCUS_SUMMARY__RECALCULATE,
    (state, action) => {
        const next = calculateMain(
            action.payload.interactionEntity,
            action.payload.mode === 'commitment'
                ? null
                : state.evaluationsDetails,
            action.payload.interactions,
            action.payload.published,
            true,
        );

        if (action.payload.mode === 'commitment') {
            next.opportunityToDemonstrate =
                next.opportunityToDemonstrateSession;
            next.willingnessToTry = next.willingnessToTrySession;
            next.proficiency = next.proficiencySession;
        }

        return {
            ...state,
            calculationResult: next,
        };
    },
);

export default {
    focusSummary: reducer,
};
